// extracted by mini-css-extract-plugin
export default {"empty":"EmptyColumns_empty__GqtGv"};